import { User } from '../typings/api';

export const formatUserName = (user: User): string => `${user?.firstName}${user?.middleInitial ? ` ${user?.middleInitial}.` : ''} ${user?.lastName}`;

export default formatUserName;
